RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    const module = (state.versioning = {});
    const versioning = RivalIQ.enums.versioning;

    /**
     * Gets a version header from XHR converting the value to a number.
     * @param {object} xhr
     * @param {string} header
     * @returns {number}
     */
    function getVersionHeader(xhr, header) {
        const value = xhr.getResponseHeader(header);
        return parseInt(value);
    }

    /**
     * Global XHR success handler for updating data and metadata versions
     * for a landscape.
     * @param {object} event
     * @param {object} xhr
     */
    module.globalXhrLandscapeHandler = function (event, xhr) {
        const dataVersion = getVersionHeader(xhr, versioning.landscape.data);
        const metadataVersion = getVersionHeader(xhr, versioning.landscape.metadata);

        if (_.isFinite(dataVersion) && _.isFinite(metadataVersion)) {
            // Invalidate caches if this request changed data or metadata
            // version
            if (RivalIQ.data.companyData &&
                dataVersion !== state.landscape.previousAttributes().data_version) {

                RivalIQ.data.CacheLayer.invalidateAllCaches(true);
            }

            state.landscape.set({
                data_version: dataVersion,
                metadata_version: metadataVersion
            }, {
                silent: true
            });
        }
    };

    /**
     * Gets XHR headers for data and metadata versions.
     * @returns {object}
     */
    module.getXhrHeaders = function () {
        const headers = {};
        headers[versioning.user.data] = state.user.get('data_version');
        headers[versioning.user.metadata] = state.user.get('metadata_version');
        headers[versioning.landscape.data] = state.landscape.get('data_version');
        headers[versioning.landscape.metadata] = state.landscape.get('metadata_version');
        return headers;
    };

    function pollHandler(data) {
        if (!data) {
            return false;
        }

        if (data.app.metadata_version !== state.product.get('metadata_version')) {
            state.landscape._isDirty = true;
        }

        if (data.landscape.metadata_version !== state.landscape.get('metadata_version')) {
            state.landscape._isDirty = true;
        }

        if (data.user.metadata_version !== state.user.get('metadata_version')) {
            // TODO should this be user state?
            state.landscape._isDirty = true;
        }

        // store the _latest_data_version on the landscape object so we can detect changes
        state.landscape._latest_data_version = data.landscape.data_version;
        if (data.landscape.data_version !== state.landscape.get('data_version')) {
            state.landscape.onNewDataAvailable(data.landscape.data_version);
        }

        if (data.user.data_version !== state.user.get('data_version')) {
            state.user.fetch();
        }

        return false;
    }

    const DATA_CHANGE_POLL_INTERVAL = 15000;

    /*
     * This method polls for indication that the client state has diverged from
     * server state.
     */
    module.poll = function () {
        _.delay(function () {
            const api = _.partial(RivalIQ.data.versions.getDataVersions, {
                landscapeId: state.landscape.get('id')
            });

            RivalIQ.utils.polling.pollUntilCondition(api, pollHandler, {
                pollingMaxAttempts: -1,
                pollingDelay: DATA_CHANGE_POLL_INTERVAL,
                retry: true
            });
        }, DATA_CHANGE_POLL_INTERVAL);
    };

});
